import { createUseStyles } from 'react-jss'
import { typography } from '@dentalux/ui-library-core'
import { forDesktopUp, forDesktopDown } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  container: {
    color: theme.palette.grey[800],
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 504,
    boxSizing: 'content-box',
    padding: '0 8px',
    margin: '0 auto',
    height: '100%',
    [forDesktopDown]: {
      padding: '0 16px 8px',
    },
  },
  patientQuestion: {
    ...typography['Lato Body 1'],
    marginBottom: 8,
    [forDesktopUp]: {
      display: 'none',
    },
  },
  patientSelectBottom: {
    marginBottom: 32,
    [forDesktopDown]: {
      marginBottom: 24,
    },
  },
  insuranceTypeQuestion: {
    ...typography['Lato Emphasized 1'],
    marginBottom: 16,
    [forDesktopDown]: {
      ...typography['Lato Body 1'],
      marginBottom: 8,
    },
  },
  insuranceSelectBottom: {
    marginBottom: 32,
    [forDesktopDown]: {
      marginBottom: 24,
    },
  },
  selectedAppointmentInfo: {
    marginBottom: 16,
    ...typography['Lato Body 2'],
  },
  seeMoreSlotsButton: {
    marginTop: 'auto',
    marginBottom: 16,
    width: '100%',
  },
}))
